import { Box } from '@mui/material';
import { useActivityLogQuery } from '../../queries';
import useUserData from 'hooks/useUserData';
import RenderLog from './RenderLog';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';

type RenderActivityLogProps = {
  searchKeyword: string;
};

function RenderActivityLog({ searchKeyword }: RenderActivityLogProps) {
  const { projectId = '' } = useParams();
  const { companyId } = useUserData();
  const { activityLog } = useActivityLogQuery({ companyId, objectId: projectId });
  const activityLogData = useMemo(
    () =>
      activityLog.filter(
        (log) =>
          !searchKeyword.trim() ||
          log.objectSubType?.toLowerCase()?.includes(searchKeyword.toLowerCase()) ||
          log.objectDescription?.toLowerCase()?.includes(searchKeyword.toLowerCase()),
      ),
    [searchKeyword, activityLog],
  );

  return (
    <Box my={1}>
      {activityLogData.map((log) => (
        <RenderLog key={log.id} log={log} searchKeyword={searchKeyword} />
      ))}
    </Box>
  );
}

export default RenderActivityLog;
